import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedDependenciesModule } from '../../../../shared/shared-dependencies.module';

import { HydraulicSchematicVddTableItemComponent } from './hydraulic-schematic-vdd-table-item/hydraulic-schematic-vdd-table-item.component';
import { HydraulicSchematicVddTableComponent } from './hydraulic-schematic-vdd-table/hydraulic-schematic-vdd-table.component';
import { HydraulicSchematicComponent } from './hydraulic-schematic.component';

@NgModule({
  imports: [SharedDependenciesModule, RouterModule],
  exports: [HydraulicSchematicComponent],
  declarations: [
    HydraulicSchematicComponent,
    HydraulicSchematicVddTableItemComponent,
    HydraulicSchematicVddTableComponent,
  ],
})
export class HydraulicSchematicsModule {}
